module.exports = __webpack_public_path__ + "img/main_sm.1514793e.jpg";